module.exports = __webpack_public_path__ + "img/university_1.e8e328a2.png";